import styled from '@emotion/styled'
import { AnimatedLine } from 'app/components/Common/Animation/AnimatedLine'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { Menu, Props as MenuProps } from 'app/containers/Footer/Menu'
import React, { memo } from 'react'

import { Bottom } from './Bottom'
import { Contacts } from './Contacts'
import { Props as PolicyMenuItemProps } from './PolicyMenuItem'

export interface Props {
  address?: string
  cin?: string
  companyName?: string
  email?: string
  facebookURL?: string
  instagramURL?: string
  languageCode: string
  linkedinURL?: string
  specialsItems?: MenuProps[]
  newsItems?: MenuProps[]
  googleMapsURL?: string
  phone?: string
  policyMenu?: { [key: string]: PolicyMenuItemProps[] }[]
  rea?: string
  registeredOffice?: string
  shareCapital?: string
  tiktokURL?: string
  vat?: string
}

export const Footer = memo(function Footer({
  address,
  cin,
  companyName,
  email,
  facebookURL,
  instagramURL,
  tiktokURL,
  linkedinURL,
  specialsItems,
  newsItems,
  googleMapsURL,
  languageCode,
  phone,
  policyMenu,
  rea,
  registeredOffice,
  shareCapital,
  vat,
}: Props) {
  return (
    <Container tag="section" dial={5} row wrap space="between">
      <AnimatedLine variant="light" />
      <Left>
        <Contacts
          address={address}
          googleMapsURL={googleMapsURL}
          email={email}
          phone={phone}
        />
      </Left>

      <Right>
        <Menu
          languageCode={languageCode}
          facebookURL={facebookURL}
          instagramURL={instagramURL}
          tiktokURL={tiktokURL}
          linkedinURL={linkedinURL}
          specialsItems={specialsItems}
          newsItems={newsItems}
        />
      </Right>
      <AnimatedLine variant="light" />
      <Bottom
        cin={cin}
        companyName={companyName}
        email={email}
        phone={phone}
        languageCode={languageCode}
        policyMenu={policyMenu}
        vat={vat}
        rea={rea}
        registeredOffice={registeredOffice}
        shareCapital={shareCapital}
      />
    </Container>
  )
})

const Container = styled(FlexBox)`
  background: ${({ theme }) => theme.colors.variants.primaryDark};

  @media (min-width: 1200px) {
    .item-line:first-of-type {
      margin-bottom: 4.5rem;
    }
  }

  .item-line {
    width: 100%;
  }

  @media (max-width: 1199px) {
    .item-line {
      margin-bottom: 0;
    }
  }
`

const Left = styled.div`
  position: relative;
  padding-left: 5.833vw;
  padding-bottom: 5rem;

  @media (max-width: 1199px) {
    width: 100%;
    padding: 3rem;
  }
`

const Right = styled(FlexBox)`
  padding-right: 12.778vw;
  padding-bottom: 4.5rem;

  @media (max-width: 1199px) {
    width: 100%;
    margin-top: 0;
    padding: 0;
  }
`
